// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"94efef15","787":"c39f7846"}[chunkId] + ".chunk.js";
};